import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VitalsResponse, VitalsState } from "./index.types";

export const initialVitalsState: VitalsState = {
  vitalsIsLoading: false,
  vitalsSuccess: null,
  vitalsData: [],
};

const name = "vitals";

export const vitalsSlice = createSlice({
  name,
  initialState: initialVitalsState,
  reducers: {
    getVitals: (state) => {
      state.vitalsIsLoading = true;
    },
    getVitalsSuccess: (state, action: PayloadAction<VitalsResponse>) => {
      state.vitalsIsLoading = false;
      state.vitalsSuccess = true;
      state.vitalsData = action.payload?.results || [];
    },
    getVitalsFail: (state) => {
      state.vitalsIsLoading = false;
      state.vitalsSuccess = false;
      state.vitalsData = [];
    },
    clearVitalsData: (state) => {
      state.vitalsIsLoading = false;
      state.vitalsSuccess = null;
      state.vitalsData = [];
    },
  },
});

export const { getVitals, clearVitalsData } = vitalsSlice.actions;

export default vitalsSlice.reducer;

export const getVitalsList = (patientId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/vitals/`,
  },
  type: "getVitals",
});
